import { render, staticRenderFns } from "./GoodsAdd.vue?vue&type=template&id=b1f84432&scoped=true&"
import script from "./GoodsAdd.vue?vue&type=script&lang=js&"
export * from "./GoodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAdd.vue?vue&type=style&index=0&id=b1f84432&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f84432",
  null
  
)

export default component.exports